$(window).scroll(function () {
    if($(window).scrollTop() > 50) {
        $('#shopify-section-header').addClass('fixed');
    } else {
        $('#shopify-section-header').removeClass('fixed');
    }
});

$(document).on('click', '.header-menu, .header-bg', function() {
    $('.header-menu___trigger').toggleClass('active')
    $("body, .header-nav").toggleClass('open')
    $(".header-bg").fadeToggle()
})